/* eslint-disable vue/no-use-v-if-with-v-for */
<template>
  <div class="container">
    <div class="hint">
      <h3>下载示例Excel</h3>
      <a @click="downloadExpense">1，点击下载</a>
      <h3>注意事项</h3>
      <span>1、 必须为.xls或.xlsx结尾的excel；</span>
      <span>2、表格中所有数据均为文本格式；</span>
      <span>3、费用总金额必须与表格中合计金额一致。</span>
    </div>
    <a-form-model
      class="content"
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="费用归属日期" prop="finance_date">
        <a-date-picker
          style="width: 300px"
          v-model="form.finance_date"
          type="date"
        />
      </a-form-model-item>
      <a-form-model-item label="项目" prop="project_id">
        <a-select
          style="width: 300px"
          showSearch
          :filterOption="filterOption"
          optionFilterProp="children"
          v-model="form.project_id"
          @change="selectedPro"
        >
          <a-select-option
            v-for="item in proList"
            :key="item.id"
            :value="item.id"
            >{{ item.project_name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="费用大类">
        <p>管家工资</p>
      </a-form-model-item>
      <a-form-model-item
        v-show="form.pid != ''"
        label="费用类型"
        prop="finance_type_id"
      >
        <a-select
          style="width: 300px"
          v-model="form.finance_type_id"
          showSearch
          :filterOption="filterOption"
          optionFilterProp="children"
        >
          <a-select-option
            v-for="item in typeList"
            :key="item.id"
            :value="item.id"
            >{{ item.name }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="结算通道" prop="paytype">
        <a-radio-group v-model="form.paytype">
          <a-radio :value="1">支付宝</a-radio>
          <a-radio :value="2">银行卡</a-radio>
        </a-radio-group>
        <span class="red-text text-float"
          >（注意：下方员工帐号必须与对应的结算通道一致，如果一批员工存在两种结算通道，分开上传提交）</span
        >
      </a-form-model-item>
      <a-form-model-item label="*员工表格" v-if="showIsExcel">
        <input class="employees-form" type="file" @change="excelData" />
      </a-form-model-item>
      <a-form-model-item label="打款至" prop="out_account_type">
        <a-radio-group v-model="form.out_account_type" class="out-box">
          <a-radio class="out-item" :value="1">员工工资、三方分开结算</a-radio>
          <a-radio
            class="out-item"
            :value="3"
            v-show="form.finance_type_id != 32"
            >结算给三方
            <span class="red-text"
              >(仅限渠道费、员工工资打包结算)</span
            ></a-radio
          >
          <a-radio class="out-item" :value="2"
            >结算给员工
            <span class="red-text">(仅限无渠道费类型)</span></a-radio
          >
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item
        label="甲方单价"
        prop="first_price"
        v-if="
          form.out_account_type == 1 ||
          form.out_account_type == 2 ||
          form.out_account_type == 3
        "
      >
        <a-input-number
          style="width: 150px"
          v-model="form.first_price"
          :min="0"
        />
      </a-form-model-item>
      <a-form-model-item
        label="员工单价"
        prop="guard_price"
        v-if="form.out_account_type == 1 || form.out_account_type == 2"
      >
        <a-input-number
          style="width: 150px"
          v-model="form.guard_price"
          :min="0"
        />
      </a-form-model-item>
      <a-form-model-item
        label="三方单价"
        prop="three_price"
        v-if="form.out_account_type == 1"
      >
        <a-input-number
          style="width: 150px"
          v-model="form.three_price"
          :min="0"
        />
        <span class="red-text">（渠道费月结的，输入0）</span>
      </a-form-model-item>
      <a-form-model-item
        label="打包单价"
        prop="pack_price"
        v-if="form.out_account_type == 3"
      >
        <a-input-number
          style="width: 150px"
          v-model="form.pack_price"
          :min="0"
        />
      </a-form-model-item>
      <a-form-model-item
        prop="third_part_id"
        label="三方"
        v-if="form.out_account_type == 3 || form.out_account_type == 1"
      >
        <a-select
          style="width: 300px"
          showSearch
          :filterOption="filterOption"
          optionFilterProp="children"
          v-model="form.third_part_id"
        >
          <a-select-option
            v-for="item in thirdList"
            :key="item.id"
            :value="item.id"
            >{{ item.name }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="费用明细" prop="detail">
        <a-input style="width: 300px" v-model="form.detail" type="textarea" />
      </a-form-model-item>
      <a-form-model-item label="图片">
        <div class="upImgStyle">
          <input
            id="travel"
            type="file"
            accept="image/*"
            @change="attentionPic"
          />
          <label for="travel">
            <a-icon type="plus" style="color: #d9d9d9; font-size: 40px" />
          </label>
          <ul>
            <li
              v-show="imageAttentionlUrl != ''"
              v-for="(item, l) in imageAttentionlUrl"
              :key="l"
            >
              <img :src="item" alt />
              <a-icon
                @click="deletedAttention(l)"
                class="close"
                type="close"
                style="color: #f56c6c"
              />
            </li>
          </ul>
        </div>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 10, offset: 5 }">
        <a-button style="margin-right: 20px" @click="resetForm">重置</a-button>
        <a-button type="primary" :loading="loading" @click="onSubmit">{{
          loading ? "提交中" : "提交"
        }}</a-button>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>
<script>
import moment from "moment";
import axios from "axios";
import * as qiniu from "qiniu-js";
export default {
  data() {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 18 },
      other: "",
      form: {
        finance_type_id: "",
        project_id: "",
        finance_date: "",
        pid: 4,
        type: "",
        amount: "",
        detail: "",
        invoice_date: "",
        invoice_type: "",
        out_account_type: "",
        paytype: "",
        third_part_id: "",
        other_info: "",
        excel: "",
        workerExcel: "",
        resume_source: "",
        is_service: "",
        first_price: "",
        guard_price: "",
        pack_price: "",
        three_price: "",
      },
      proList: [],
      parentsList: [],
      typeList: [],
      showIsExcel: true,
      rules: {
        resume_source: [
          {
            required: true,
            message: "请选择渠道",
            trigger: "change",
          },
        ],
        is_service: [
          {
            required: true,
            message: "请选择是否包含服务费",
            trigger: "change",
          },
        ],
        first_price: [
          {
            required: true,
            message: "请填写甲方单价",
            trigger: "blur",
          },
          {
            pattern:
              /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
            message: "请输入正确金额格式，可保留两位小数",
          },
        ],
        guard_price: [
          {
            required: true,
            message: "请填写员工单价",
            trigger: "blur",
          },
          {
            pattern:
              /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
            message: "请输入正确金额格式，可保留两位小数",
          },
        ],
        pack_price: [
          {
            required: true,
            message: "请填写打包单价",
            trigger: "blur",
          },
          {
            pattern:
              /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
            message: "请输入正确金额格式，可保留两位小数",
          },
        ],
        three_price: [
          {
            required: true,
            message: "请填写三方单价",
            trigger: "blur",
          },
          {
            pattern:
              /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
            message: "请输入正确金额格式，可保留两位小数",
          },
        ],
        finance_date: [
          {
            required: true,
            message: "请选择费用归属日期",
            trigger: "change",
          },
        ],
        type: [
          {
            required: true,
            message: "请选择结算类型",
            trigger: "change",
          },
        ],
        excel: [
          {
            required: true,
            message: "请上传员工数据",
            trigger: "change",
          },
        ],
        out_account_type: [
          {
            required: true,
            message: "请选择打款账户",
            trigger: "change",
          },
        ],
        paytype: [
          {
            required: true,
            message: "请选择结算通道",
            trigger: "change",
          },
        ],
        other_info: [
          {
            required: true,
            message: "请填写其他账户信息",
            trigger: "blur",
          },
        ],
        project_id: [
          {
            required: true,
            message: "请选择项目",
            trigger: "change",
          },
        ],
        pid: [
          {
            required: true,
            message: "请选择费用大类",
            trigger: "change",
          },
        ],
        finance_type_id: [
          {
            required: true,
            message: "请选择费用类型",
            trigger: "change",
          },
        ],
        invoice_type: [
          {
            required: true,
            message: "请选择发票类型",
            trigger: "blur",
          },
        ],
        invoice_send_type: [
          {
            required: true,
            message: "请选择递交方式",
            trigger: "blur",
          },
        ],
        invoice_send_no: [
          {
            required: true,
            message: "请填写快递单号",
            trigger: "blur",
          },
        ],
        amount: [
          {
            required: true,
            message: "请填写金额",
            trigger: "blur",
          },
        ],
        third_part_id: [
          {
            required: true,
            message: "请选择三方",
            trigger: "blur",
          },
        ],
        detail: [
          {
            required: true,
            message: "请填写费用明细",
            trigger: "blur",
          },
        ],
      },
      imageAttentionlUrl: [],
      getToken: [],
      thirdList: [],
      dateFormat: "YYYY-MM-DD",
      loading: false,
    };
  },
  mounted() {
    this.getPro(); //获取项目
    // this.getParents(); //获取大类
    this.getType(); //获取类型
    this.getThirdCompany(); //获取三方公司
  },
  methods: {
    downloadExpense() {
      window.location.href =
        this.httpsBasic.url +
        this.httpsBasic.finance +
        "Reimbursement/downBatchGuardInfo?token=" +
        window.localStorage.getItem("xnwfPcToken");
    },
    excelData(e) {
      this.form.excel = e.target.files[0];
      // this.form.fileName = e.target.files[0].name;
    },
    getThirdCompany() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.finance +
        "Reimbursement/getThirdPartByProjectId";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          project_id: this.form.project_id,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.thirdList = res.data.data;
            // console.log(this.thirdList);
          }
        });
    },
    attentionPic(e) {
      if (e.target.files != "") {
        this.getUpImgToken(e);
        let reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onloadend = () => {
          this.imageAttentionlUrl.push(reader.result);
        };
      }
    }, //注意事项图片
    getUpImgToken(e) {
      let self = this;
      let url = this.httpsBasic.url + "cloud/Qiniu/getToken";
      axios
        .post(url, {
          count: 1,
        })
        .then((res) => {
          this.getToken.push(res.data.data.business_file_key);
          // console.log(this.getToken1);
          var config = {
            useCdnDomain: true,
            region: qiniu.region.z0,
          };
          var putExtra = {
            fname: "",
            params: {},
            mimeType: null,
          };
          var observable = qiniu.upload(
            e.target.files[0],
            res.data.data.keys[0],
            res.data.data.token,
            putExtra,
            config
          );
          var observer = {
            next(res) {
              // console.log("上传中...");
            },
            error(err) {
              // console.log(err)
              self.$info({
                title: "提示",
                content: "错误码：" + err.code + "！请重新选择图片",
                onOk() {},
              });
              self.imageAttentionlUrl = "";
            },
            complete(res) {
              // console.log("上传成功");
            },
          };
          var subscription = observable.subscribe(observer); // 上传开始
        });
    }, //上传至七牛云
    deletedAttention(key) {
      this.imageAttentionlUrl.splice(key, 1);
      this.getToken.splice(key, 1);
    }, //删除注意事项图片
    getParents() {
      let url =
        this.httpsBasic.url + this.httpsBasic.finance + "Finance_type/getLeave";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        pid: 0,
      };
      axios.post(url, params).then((res) => {
        if (res.data.code == 200) {
          this.parentsList = res.data.data;
          // console.log(this.parentsList);
        }
      });
    },
    getType() {
      let url =
        this.httpsBasic.url + this.httpsBasic.finance + "Finance_type/getLeave";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        pid: this.form.pid,
        finance_source_id: 2,
      };
      axios.post(url, params).then((res) => {
        if (res.data.code == 200) {
          this.typeList = res.data.data;
          this.typeList = this.typeList.filter((val) => {
            return val.id != 44;
          });
          // console.log(this.typeList)
        }
      });
    },
    getPro() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.proList = res.data.data;
            //  console.log(this.proList);
          }
        });
    },
    selectedPro(val) {
      this.form.third_part_id = "";
      this.getThirdCompany(); //获取三方公司
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },

    putData(out_account_type) {
      let formData = new FormData();
      formData.append("token", window.localStorage.getItem("xnwfPcToken"));
      formData.append("finance_type_id", this.form.finance_type_id);
      formData.append("project_id", this.form.project_id);
      formData.append(
        "finance_date",
        this.form.finance_date.length == 10
          ? this.form.finance_date
          : moment(this.form.finance_date).format("YYYY-MM-DD")
      );
      formData.append("paytype", this.form.paytype);
      formData.append(
        "out_account_type",
        out_account_type ? out_account_type : this.form.out_account_type
      );
      formData.append(
        "third_part_id",
        this.form.out_account_type == 3 || this.form.out_account_type == 1
          ? this.form.third_part_id
          : ""
      );
      formData.append("excel", this.form.excel);
      formData.append("images", JSON.stringify(this.getToken));
      formData.append("is_and", this.form.out_account_type == 1 ? 1 : 2);
      formData.append("detail", this.form.detail);
      formData.append("first_price", this.form.first_price);
      formData.append(
        "guard_price",
        this.form.out_account_type != 3 ? this.form.guard_price : ""
      );
      formData.append(
        "pack_price",
        this.form.out_account_type == 3 ? this.form.pack_price : ""
      );
      formData.append(
        "three_price",
        this.form.out_account_type !=2 ? this.form.three_price : ""
      );
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      let url =
        this.httpsBasic.url +
        this.httpsBasic.finance +
        "Reimbursement/adminAddNew";
      this.loading = true;
      axios
        .post(url, formData, config)
        .then((res) => {
          this.loading = false;
          if (res.data.code == 200) {
            this.resetForm();
            this.$message.success("提交成功");
            setTimeout(() => {
              this.$emit("hideInAdd", true);
            }, 300);
          } else {
            this.$info({
              title: "提示",
              content: res.data.message,
              onOk() {},
            });
          }
        })
        .catch((err) => {
          this.$message.error("服务器出错了...");
        });
    },
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.form.excel != "") {
            if (this.form.out_account_type == 1) {
              this.putData(2); // 员工
              this.putData(3); // 三方
            } else {
              this.putData();
            }
          } else {
            this.$message.warning("请上传文件");
          }
          // out_account_type == 1 代表员工工资、三方分开结算 out_account_type    2员工out_account_type    3三方
        } else {
          // console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      this.getToken = [];
      this.imageAttentionlUrl = [];
      this.showIsExcel = false;
      setTimeout((res) => {
        this.showIsExcel = true;
      }, 10);
      this.$refs.ruleForm.resetFields();
    },
  },
};
</script>
<style lang="less" scoped>
.container {
  position: relative;
}

.content {
  margin-top: 30px;
  padding-bottom: 30px;

  .ant-form-item {
    margin-bottom: 14px;
  }

  .upImgStyle {
    position: relative;
    display: inline-block;
    min-width: 300px;
    vertical-align: top;

    > input {
      vertical-align: top;
      opacity: 0;
      position: absolute;
      width: 100px;
      height: 100px;
      margin-right: 10px;
      margin-top: 10px;
      z-index: 1;
    }

    > label {
      vertical-align: top;
      display: inline-block;
      border: 1px solid #d9d9d9;
      width: 100px;
      height: 100px;
      text-align: center;
      line-height: 100px;
      margin-right: 10px;
      margin-top: 10px;

      i {
        line-height: 100px;
      }
    }

    > ul {
      display: inline-block;

      li {
        display: inline-block;
        position: relative;
        margin-top: 10px;

        img {
          display: inline-block;
          width: 100px;
          height: 100px;
          object-fit: cover;
          margin-right: 10px;
          border: 1px solid #d9d9d9;
          margin-bottom: 10px;
        }

        .close {
          position: absolute;
          right: 8px;
          top: 2px;
          font-size: 24px;
          color: #333;
        }
      }
    }
  }

  .out-box {
    display: flex;
    flex-direction: column;

    .out-item {
      margin-top: 16px;
    }

    .out-item:first-child {
      margin-top: 10px;
    }
  }

  .red-text {
    color: red;
  }

  .employees-form {
    margin-top: 6px;
    height: 30px;
    line-height: 20px;
  }
}

.hint {
  background: rgba(230, 162, 60, 0.1);
  padding: 10px 20px;
  margin: 10px 30px 20px;
  width: 400px;
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 1;

  a {
    display: block;
    font-size: 14px;
    margin-bottom: 10px;
    line-height: 24px;
  }

  h3 {
    color: #666;
    font-size: 16px;
    font-weight: normal;
    margin: 0;
  }

  span {
    display: block;
    font-size: 14px;
    line-height: 24px;
    color: #666;
  }
}
</style>
